import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconSuperiorRoom = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconSuperiorRoom",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M19.2 12.5V9.8c0-.99-.81-1.8-1.8-1.8H6.6c-.99 0-1.8.81-1.8 1.8v2.7c-.99 0-1.8.81-1.8 1.8v4.5h1.2l.46 1.38a.63.63 0 0 0 1.18 0l.46-1.38h11.4l.46 1.38c.09.25.32.42.59.42s.5-.17.6-.42l.45-1.38H21v-4.5c0-.99-.81-1.8-1.8-1.8m-8.1 0H6.6v-1.8c0-.5.4-.9.9-.9h3.6zm6.3 0h-4.5V9.8h3.6c.5 0 .9.4.9.9zM14.56 2.41l-.87 1.21-.84-1.48a.27.27 0 0 0-.48 0l-.84 1.48-.85-1.48a.27.27 0 0 0-.47 0l-.85 1.48-.87-1.2a.27.27 0 0 0-.49.15v3.5c0 .15.12.27.27.27h6.51c.15 0 .27-.12.27-.27v-3.5a.27.27 0 0 0-.5-.16M9.08 4.98a.27.27 0 1 1 0-.54.27.27 0 0 1 0 .54m1.63 0a.27.27 0 1 1 0-.54.27.27 0 0 1 0 .54m1.63 0a.27.27 0 1 1 0-.54.27.27 0 0 1 0 .54m1.63 0a.27.27 0 1 1 0-.54.27.27 0 0 1 0 .54"
  })
}));
IconSuperiorRoom.displayName = 'IconSuperiorRoom';